import { render, staticRenderFns } from "./MatchNotStarted.vue?vue&type=template&id=71bdbff2&scoped=true"
import script from "./MatchNotStarted.vue?vue&type=script&lang=js"
export * from "./MatchNotStarted.vue?vue&type=script&lang=js"
import style0 from "./MatchNotStarted.vue?vue&type=style&index=0&id=71bdbff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bdbff2",
  null
  
)

export default component.exports